import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@nosible/shared/components/ui/tabs";
import {
  StripeOverview,
  StripeCustomers,
  StripeCheckouts,
  StripeWebhooks,
} from "@/admin/components/stripe";
import { CreditCard } from "lucide-react";

export function AdminStripe() {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center gap-2">
        <CreditCard className="h-6 w-6 text-violet-pulse" />
        <h1 className="text-2xl font-bold text-silica font-display">Admin: Stripe</h1>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="bg-slate-core border border-white/10">
          <TabsTrigger value="overview" className="text-chromium-mist data-[state=active]:bg-obsidian data-[state=active]:text-ghost-white">Overview</TabsTrigger>
          <TabsTrigger value="customers" className="text-chromium-mist data-[state=active]:bg-obsidian data-[state=active]:text-ghost-white">Customers</TabsTrigger>
          <TabsTrigger value="checkouts" className="text-chromium-mist data-[state=active]:bg-obsidian data-[state=active]:text-ghost-white">Checkouts</TabsTrigger>
          <TabsTrigger value="webhooks" className="text-chromium-mist data-[state=active]:bg-obsidian data-[state=active]:text-ghost-white">Webhooks</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <StripeOverview />
        </TabsContent>

        <TabsContent value="customers" className="space-y-6">
          <StripeCustomers />
        </TabsContent>

        <TabsContent value="checkouts" className="space-y-6">
          <StripeCheckouts />
        </TabsContent>

        <TabsContent value="webhooks" className="space-y-6">
          <StripeWebhooks />
        </TabsContent>
      </Tabs>
    </div>
  );
}
